export default function DocumentsView() {
  return <h1>Documents</h1>;
}
